import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { AdminModule } from '@/store/modules/admin';
import Account from './components/Account.vue';
import Activity from './components/Activity.vue';
import Timeline from './components/Timeline.vue';
import UserCard from './components/UserCard.vue';
const defaultProfile = {
  name: 'Loading...',
  email: 'Loading...',
  avatar: 'Loading...',
  roles: 'Loading...'
};
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.user = defaultProfile;
    this.activeTab = 'account';
  }
  get name() {
    return AdminModule.name;
  }
  get email() {
    return AdminModule.email;
  }
  get avatar() {
    return AdminModule.avatar;
  }
  get roles() {
    return AdminModule.roles;
  }
  activated() {
    this.getUser();
  }
  getUser() {
    this.user = {
      name: this.name,
      email: this.email,
      avatar: this.avatar,
      roles: this.roles.join(' | ')
    };
  }
};
default_1 = __decorate([Component({
  name: 'Profile',
  components: {
    Account,
    Activity,
    Timeline,
    UserCard
  }
})], default_1);
export default default_1;